export { Avatar as ContactAvatar } from '@tinycld/core/components/Avatar'
